import { createUserManager } from 'redux-oidc';

const tokenServiceUrl = () =>
{
    switch (window.location.hostname) {
        case 'salesforce-uat03.reico.com':
        case 'salesforce-uat04.reico.com':
            return 'https://identity-uat01.reico.com';
        case 'salesforce.reico.com':
        case 'salesforce2.reico.com':
            return 'https://identity.reico.com';
        case 'localhost':
            return 'https://localhost:44303';
        case 'salesforce-t03.reico.com':
        case 'salesforce-t03-4608.reico.com':
        case 'reicodistributors-t03-4609.reico.com':
        case 'salesforce-t04.reico.com':
        default:
            return 'https://t01-identity.reico.com';
    }
};

const userManagerConfig = {
    client_id: "reico_salesforce",
    response_type: "id_token token",
    scope: "openid profile email bridgeapi",

    automaticSilentRenew: true,
    filterProtocolClaims: true,

    authority: tokenServiceUrl(),
    redirect_uri: `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}/prod-mgmt/callback`,
    silent_redirect_uri: `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}/prod-mgmt/silent_renew`,
    post_logout_redirect_uri: `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}/prod-mgmt`
};

const userManager = createUserManager(userManagerConfig);

export default userManager;